var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgViewEyeOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 12.465l1.425.465.001-.003C3.036 12.604 5.294 6 12.188 6c6.914 0 9.112 6.637 9.202 6.922l1.433-.45C22.8 12.39 20.213 4.5 12.195 4.5S1.523 12.39 1.5 12.465zm14.415-.518a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zm-3.165.803a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
    fill: "#6D6D6D"
  })));
}

export default SvgViewEyeOutline;